const module = { name: 'theater/details/shared/showtimes', exports: {} }; const exports = module.exports;



import { Fandango as Fandango } from 'require-core';



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_queryUtil as Fandango_queryUtil_getParam } from 'require-core';

const { getParam } = Fandango_queryUtil_getParam;


import { Fandango_util as Fandango_util_lazyLoad } from 'require-global';

const { lazyLoad } = Fandango_util_lazyLoad;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as formatFilter } from 'swug-fdRequire-call:movie/shared/formatFilter';



import { fd_url_manager as links } from 'require-core';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { default as offerModal } from 'swug-fdRequire-call:shared/offerModal';



import { shared_global_smoothScroll as smoothScroll } from 'require-global';



import { default as sharedShowtimes } from 'swug-fdRequire-call:shared/sharedShowtimes';



import { swig as swig } from 'require-core';



import { Fandango_util as util } from 'require-global';



import { Fandango_xhr as xhr } from 'require-core';



import { Fandango as Fandango_context } from 'require-core';

const { context: { featureFlags: { seatMapPreviewEnabled } } } = Fandango_context;


import { default as seatMap } from 'swug-fdRequire-call:shared/seatMap/seatMap';



import { default as amenityDropdown } from 'swug-fdRequire-call:desktop/shared/amenityDropdown';



const { chainCode, isDesktop, isMobile, theaterCountry, theaterId, partnerRestrictedTicketing, } = readPageContext(Fandango)


const Selectors = {
    MOVIE_INFO: 'lazyload-movie-times',
    MOVIE_OFFER_MODAL: 'movie-offer-modal',
    OFFER_CTA: '.js-offer-cta',
    SHARED_MOVIE_SHOWTIMES: 'shared-movie-showtimes',
    SHARED_SHOWTIMES: 'shared-showtimes',
}


let selectedDate


let rawData
function readPageContext(Fandango) {
    const { context, pageDetails } = Fandango;
    const isMobile = context.device.isMobile;
    return {
        isMobile,
        isDesktop: !isMobile,
        theaterCountry: context.theater?.details?.country,
        theaterId: context.theater?.details?.id,
        chainCode: context.theater?.chainCode,
        partnerRestrictedTicketing: pageDetails?.partnerRestrictedTicketing,
    };
}
function notifyUnavailable() {
    track({
        event: EventTypes.DATE_SHOWTIME,
        showtimePresence: false,
        selectedDate,
        theaterHasMatinee: false
    });
    const container = document.getElementById(Selectors.MOVIE_INFO);
    if (!container) {
        return;
    }
    container.innerHTML = '<div class="fd-panel dark__bordered__section">No showtimes available for this day.</div>';
}
function onFetchDone(data, filter, cb) {
    if (!data || !data.viewModel) {
        notifyUnavailable();
        return cb(true, null);
    }
    if (!document.getElementById(Selectors.MOVIE_INFO)) {
        return cb(true, null);
    }
    rawData = { ...data.viewModel, formats: data.viewModel.formats };
    applyFilter(filter);
    amenityDropdown.run();
    cb(null, rawData);
}
function filterMovieList(filter, movies) {
    if (filter === formatFilter.FormatFilters.ALL) {
        return movies;
    }
    return movies
        .filter(movie => Array.isArray(movie?.variants) || movie.variants.length)
        .map(movie => ({
        ...movie,
        sourceVariants: movie.variants.map(variant => ({ ...variant, sourceAmenityGroups: variant.amenityGroups }))
    }))
        .filter((movie) => {
        movie.variants = movie.variants.map((variant, index) => ({
            ...variant,
            amenityGroups: movie.sourceVariants[index].sourceAmenityGroups
                .filter(group => group.showtimes.some(showtime => showtime.filmFormat.some(f => f.filterName === filter)))
        }));
        return movie.variants.some(variant => variant.amenityGroups.length > 0);
    });
}
function applyFilter(filter) {
    if (!rawData) {
        debugLog.warn(`${module.name}'.applyFilter`, 'no data ready/available');
        return;
    }
    const { date, theater, formats } = rawData;
    if (!filter || !formats.includes(filter)) {
        debugLog.warn(`${module.name}'.applyFilter`, 'invalid filter, using "ALL"');
        filter = formatFilter.FormatFilters.ALL;
    }
    const movies = filterMovieList(filter, rawData.movies);
    track({
        event: EventTypes.DATE_SHOWTIME,
        showtimePresence: true,
        selectedDate,
        theaterHasMatinee: movies.some(item => item.hasMatinee),
    });
    const viewModel = { activeFilter: filter.toUpperCase(), hasShowtimes: Boolean(movies.length) };
    document.getElementById(Selectors.MOVIE_INFO).innerHTML = swig.render('_theaterMovieShowtimes', viewModel);
    const movieShowtimesEl = document.getElementById(Selectors.SHARED_MOVIE_SHOWTIMES);
    if (movieShowtimesEl) {
        movieShowtimesEl.outerHTML = swig.render('_sharedMovieShowtimes', { includeIDs: true, isMobile, movies });
    }
    movies.forEach((movie) => {
        const { offer } = movie;
        if (offer && isMobile) {
            const offerModalEl = document.getElementById(`${Selectors.MOVIE_OFFER_MODAL}-${movie.id}`);
            if (offerModalEl) {
                offerModalEl.outerHTML = swig.render('_offeringModal', {
                    ...offer,
                    headline: offer.title,
                    id: `${offer.id}-${movie.id}`,
                    isMobile,
                    modalTitle: offer.offerText,
                });
            }
        }
        const showtimesEl = document.getElementById(`${Selectors.SHARED_SHOWTIMES}-${movie.id}`);
        if (showtimesEl) {
            showtimesEl.innerHTML = swig.render('_sharedShowtimes', {
                movie,
                seatMapPreviewEnabled,
                showtimeDate: date,
                theater: { ...theater.details, isTicketing: theater.isTicketing },
                variants: seatMap.addSeatMapData(movie.variants),
            });
        }
    });
    lazyLoad();
    const anchor = getParam(QueryParams.MOVE_TO) || window.location.hash.slice(1);
    smoothScroll.run(anchor);
    modal.offers(Selectors.OFFER_CTA);
    sharedShowtimes.init();
    offerModal.init();
    seatMap.renderModal();
}
function load(date, filter, cb) {
    selectedDate = date;
    const params = {
        chainCode,
        startDate: selectedDate || util.formatDate(new Date()),
        isdesktop: isDesktop,
        partnerRestrictedTicketing,
        theaterCountry,
    };
    xhr.ajax({
        method: 'GET',
        url: links.napiTheaterMovieShowtimes({
            id: theaterId,
        }),
        data: params,
    })
        .done(data => onFetchDone(data, filter, cb))
        .fail((err) => {
        notifyUnavailable();
        cb(err || true, null);
    });
}
module.exports = {
    applyFilter,
    load,
    notifyUnavailable,
};
export default module.exports;